module.exports = __webpack_public_path__ + "img/Merdeka-03-R2.814256c6.jpg";